"use client";
import { DrupalNode } from "next-drupal";
import React from "react";
import { motion } from "framer-motion";

interface ReviewSectionProps {
  data: DrupalNode;
  id?: string;
}

const ReviewSection = ({ data, id }: ReviewSectionProps) => {
  return (
    <div
      id={id}
      className="pt-[60px] pb-[140px] bg-mapGray relative z-[2] mobileMax:pt-5  mobileMax:pb-14 betweenMobileTab:pb-24 betweenMobileTab:pt-[60px] overflow-hidden"
    >
      <div className="mini-container relative z-[1]">
        {data?.field_review_card?.map(
          (testimonialData: DrupalNode, index: number) => {
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{
                  duration: 0,
                }}
                className="remove-animation-fluctuation mt-24 mobileMax:mt-12 remove-animation-fluctuation"
              >
                <div
                  className="Cta-testomonial --font-poppins font-medium text-[24px] leading-snug italic text-center text-[#003350] leading-8 mb-8 resources-links mobileMax:text-xsmall mobileMax:leading-normal relative"
                  dangerouslySetInnerHTML={{
                    __html: testimonialData?.field_description.processed,
                  }}
                />
                <h6 className="text-right font-semibold text-[32px] uppercase italic bg-[linear-gradient(to_right,#8ebce5,#11375c)] text-clip mobileMax:text-xsmall leading-normal pr-2">
                  {testimonialData.field_name}
                </h6>
              </motion.div>
            );
          },
        )}
      </div>
    </div>
  );
};

export default ReviewSection;
